export default __webpack_public_path__ + "static/media/appstore.304c25ca.png";